import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



export default function ClubVerification() {
    const {
        details,
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const legalForm = details.legal_form;

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    const getVerificationMessage = () => {
        if (legalForm === "societe") {
            return {
                title: t("clubVerification.requiredTitle"),
                text: t("clubVerification.companyText"),
            };
        }

        if (legalForm === "association") {
            return {
                title: t("clubVerification.requiredTitle"),
                text: t("clubVerification.associationText"),
            };
        }

        return {
            title: t("clubVerification.requiredTitle"),
            text: t("clubVerification.institutionText"),
        };
    };

    const message = getVerificationMessage();

    return (
        <div className="verification-wrapper">

            {/* TOP MESSAGE */}
            <VerificationInfo
                title={message.title}
                text={message.text}
            />

            {/* CONTENT */}
            <div className="verification-content">

                {legalForm === "societe" && (
                    <UploadBox
                        label={t("clubVerification.tradeRegister")}
                        name="club_rc"
                        file={verificationData.club_rc}
                        onChange={handleFile}
                    />
                )}

                {(legalForm === "association" ||
                    legalForm === "institution") && (
                        <UploadBox
                            label={t("clubVerification.officialStatus")}
                            name="club_statuts"
                            file={verificationData.club_statuts}
                            onChange={handleFile}
                        />
                    )}

            </div>

            {/* BOTTOM */}
            <PrivacyNotice />

        </div>
    );
}

function VerificationInfo({ title, text }) {

    const { t } = useTranslation();

    return (
        <div className="verification-info-card">
            <div className="verification-badge">
                ✓ {t("clubVerification.carrerupVerification")}
            </div>

            <h3>{title}</h3>

            <p>{text}</p>
        </div>
    );
}

function PrivacyNotice() {

    const { t } = useTranslation();

    return (
        <div className="verification-privacy">
            🔒 {t("clubVerification.privacy")}
        </div>
    );
}

function UploadBox({ label, name, file, onChange }) {
    return (
        <div className="input-wrapper full-width">
            <label className="pdf-upload-label">
                {label}

                <input
                    required
                    type="file"
                    name={name}
                    accept=".pdf,image/*"
                    hidden
                    onChange={onChange}
                />
            </label>

            {file && (
                <div className="pdf-selected">
                    📄 {file.name}
                </div>
            )}
        </div>
    );
}